// File: store/profile.js
// Purpose: State store for the Profile view.
export default {
  header: "Profile",
  view: "Profile"
};
